module.exports = __webpack_public_path__ + "static/undraw-dev-ffbbef964360a2b7aef095eb5c6680e7.svg";